export type Status = 'idle' | 'pending' | 'resolved' | 'rejected';
export enum STATUS {
    IDLE = 'idle',
    PENDING = 'pending',
    RESOLVED = 'resolved',
    REJECTED = 'rejected',
}
export type AssetsPredictPrice = {
    assetId: string,
    shares: {
        primaryMarket: number,
        secondaryMarket: number,
        primaryMarketPrice: number,
        secondaryMarketPrice: number,
        secondaryMarketUnitaryPrice: number,
    },
};
